<template>
  <div class="shopping_cart">
    <div id="cart" class="btn-shopping-cart">
      <a href="javascript:void(0)" data-loading-text="Loading... " class="btn-group top_cart dropdown-toggle"
        data-toggle="dropdown" aria-expanded="true">
        <div class="shopcart">
          <a href="/cart" title="Ver mi pedido" data-toggle="tooltip" data-placement="top" @click="openCart">
            <span class="icon-c">
              <i class="fa fa-shopping-basket"></i>
            </span>
          </a>
          <div class="shopcart-inner">
            <p class="text-shopping-cart">
              Pedido
            </p>

            <span class="total-shopping-cart cart-total-full">
              <span class="items_cart">{{ cartStore.items.length }}</span><span class="items_cart2"> item(s)</span><span
                class="items_carts">{{ formatterCurrency(cartStore.totalCost) }}</span>
            </span>
          </div>
        </div>
      </a>

      <ul class="dropdown-menu pull-right shoppingcart-box cartDropdownMenu" role="menu"
        v-if="cartStore.items.length > 0">
        <li>
          <table class="table table-striped">
            <tbody>
              <tr v-for="(product, index) in cartStore.sortedItems" :key="index">
                <td class="text-center" style="width:70px">
                  <a href="#!">
                    <img
                      :src="`${product.options.image ? ('/uploads/' + product.options.image) : '/dist/images/not-image.svg'}`"
                      style="width:70px" :alt="product.name" :title="product.name" class="preview">
                  </a>
                </td>
                <td class="text-left">
                  <a class="cart_product_name" href="#!">
                    {{
                      `${product.name} (x ${product.options.bulk_items})`
                    }}
                  </a>
                </td>
                <td class="text-center" style="width:40px">x {{ product.qty }}</td>
                <td class="text-center">{{ formatterCurrency(product.price) }}</td>
                <td class="text-right">
                  <a @click="cartStore.removeItem(product.rowid)" class="fa fa-times fa-delete"></a>
                </td>
              </tr>
            </tbody>
          </table>
        </li>
        <li>
          <div>
            <table class="table table-bordered">
              <tbody>
                <!-- <tr>
                  <td class="text-left"><strong>Sub-Total</strong>
                  </td>
                  <td class="text-right">{{ formatterCurrency(cartStore.totalCost) }}</td>
                </tr> -->
                <!-- <tr>
                  <td class="text-left"><strong>Eco Tax (-2.00)</strong>
                  </td>
                  <td class="text-right">$2.00</td>
                </tr> -->
                <!-- <tr>
                  <td class="text-left"><strong>VAT (20%)</strong>
                  </td>
                  <td class="text-right">$20.00</td>
                </tr> -->
                <tr>
                  <td class="text-left"><strong>Total</strong>
                  </td>
                  <td class="text-right">
                    <h3>{{ formatterCurrency(cartStore.totalCost) }}</h3>
                  </td>
                </tr>
              </tbody>
            </table>
            <p class="text-center">
              <a class="btn view-cart" href="/cart">
                <i class="fa fa-shopping-cart"></i> Ver pedido
              </a>&nbsp;&nbsp;&nbsp;
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import useCartStore from "../../stores/cart";

import {
  ref,
  onMounted,
  getCurrentInstance,
  computed,
  defineExpose,
} from "vue";

const props = defineProps({
  defaultCurrency: {
    type: String,
    required: true,
  },
  exchangeRate: {
    type: Number,
    required: false,
    default: 1
  }
});
const cartStore = useCartStore;


const emit = defineEmits([]);

const formatterCurrency = (val) => {
  try {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: props.defaultCurrency,
    }).format(val);
  } catch (error) {
    return "Error";
  }

};

const openCart = () => {
  location.href = "/cart";
};

onMounted(() => {
  let instance = getCurrentInstance();
});

defineExpose({});
</script>

<style type="text/css" scoped>
.view-cart {
  font-size: 1.2em;
}
</style>